import { css } from 'aphrodite';
import * as React from 'react';
import { Toggle } from '../../components/Toggle';
import { THEME } from '../Theme/theme';
import { LogoOverlayGallery } from './LogoOverlayGallery';
import { s } from './styles';
import { LogoOverlayOptions } from './types';

export function LogoOverlayTab({
	hideWhiteBackground,
	images,
	initialIndex,
	isBurnedIn,
	isEnabled,
	logoUrl,
	onEnabledChange,
	onSizeChange,
	readOnly,
	size,
}: LogoOverlayOptions) {
	const showLogo = isEnabled && !isBurnedIn;

	return (
		<div className={css(s.logoOverlayTab)}>
			{isBurnedIn ? (
				<p className={css(s.logoOverlayNote)}>Your logo is already part of this media, so its size is settled.</p>
			) : (
				<div className={css(s.logoOverlayToggleRow)}>
					<Toggle
						checkedColor={THEME.colors.primary.main}
						disabled={readOnly}
						id='unified-image-dialog-overlay-logo'
						isOn={isEnabled}
						onToggleCheckChanged={onEnabledChange}
						uncheckedColor={THEME.colors.border.main}
					/>
					<label className={css(s.logoOverlayToggleLabel)} htmlFor='unified-image-dialog-overlay-logo'>
						Overlay my logo on this post&apos;s images
					</label>
				</div>
			)}
			<LogoOverlayGallery
				hideWhiteBackground={hideWhiteBackground}
				images={images}
				initialIndex={initialIndex}
				logoUrl={logoUrl}
				onSizeChange={showLogo && !readOnly ? onSizeChange : undefined}
				showLogo={showLogo}
				size={size}
			/>
		</div>
	);
}
